
<template>

    <div>
        <section class="row margin-b-50">

            <header class="shop__header margin-b-50">

                <h1>Bekræftelse</h1>

                <p>Nedenfor finder du oplysningerne du har angivet i din bestilling.
                    Vi beder dig gennemgå disse nøje, således at du sikrer dig, disse er korrekte.</p>

                <p>Skulle du ønske at ændre nogle oplysninger, kan du gå tilbage i trinnene, ved at klikke på et trin øverst i menuen.</p>

            </header>

            <section class="row shop__list">

                <h1>Dine oplysninger</h1>

                <ul>
                    <li v-for="item in information">{{(item !== information.comment) ? item:''}}</li>
                </ul>

                <template v-if="information.comment">
                    <h1>Dine bemærkninger</h1>

                    <ul>
                        <li>
                            <p v-text="information.comment"></p>
                        </li>
                    </ul>

                </template>

            </section>

        </section>

        <section class="row">

            <header class="shop__header margin-b-50">

                <h1>Din ordre</h1>

                <p>Vi beder dig gennemgå disse og sikre dig, at disse er korrekte, samt at gennemgå og acceptere vores betalingsbetingelser.</p>

            </header>

            <!-- Desktop table -->

            <template v-if="!isMobile">

                <div class="table">

                    <section class="table__header base-color-30">

                        <section class="table__item--lg">

                            <p>Produkt navn</p>

                        </section>

                        <section class="table__item--sm">

                            <p>Antal</p>

                        </section>

                        <section class="table__item--sm">

                            <p>Pris</p>

                        </section>

                    </section>

                    <section class="table__body">

                        <section class="table__row">

                            <section class="table__item--lg">

                                <p>{{product.title}}</p>

                            </section>

                            <section class="table__item--sm">

                                <p>{{orderDetails.product.quantity}}</p>

                            </section>

                            <section class="table__item--sm">

                                <p>{{formatCurrency(orderDetails.product.quantity * orderDetails.product.price)}}<span>DKK</span></p>

                            </section>

                        </section>

                        <template v-for="subProduct in orderDetails.subProducts">

                            <section class="table__row" v-if="subProduct.quantity > 0">

                                <section class="table__item--lg">

                                    <p>{{subProduct.title}}</p>

                                </section>

                                <section class="table__item--sm">

                                    <p>{{subProduct.quantity}}</p>

                                </section>

                                <section class="table__item--sm">

                                    <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                                </section>

                            </section>

                        </template>


                        <!-- spacer row -->

                        <section class="table__row padding-tb-15">

                            <section class="table__item--lg">

                            </section>

                            <section class="table__item--sm">

                            </section>

                            <section class="table__item--sm">

                            </section>

                        </section>

                        <!-- total price row -->

                        <section class="table__row">

                            <section class="table__item--lg">

                                <p><strong>Samlet pris uden moms</strong></p>

                            </section>

                            <section class="table__item--sm">

                            </section>

                            <section class="table__item--sm">

                                <p><strong>{{formatCurrency(totalWithoutTaxes)}}<span>DKK</span></strong></p>

                            </section>

                        </section>


                        <section class="table__row">

                            <section class="table__item--lg">

                                <p><strong>Moms</strong></p>

                            </section>

                            <section class="table__item--sm">

                            </section>

                            <section class="table__item--sm">

                                <p><strong>{{formatCurrency(totalTaxes)}}<span>DKK</span></strong></p>

                            </section>

                        </section>

                        <section class="table__row">

                            <section class="table__item--lg">

                                <p><strong>Samlet pris</strong></p>

                            </section>

                            <section class="table__item--sm">

                            </section>

                            <section class="table__item--sm">

                                <p><strong>{{formatCurrency(totalWithTaxes)}}<span>DKK</span></strong></p>

                            </section>

                        </section>

                    </section>

                </div>

            </template>

            <!-- Mobile table -->

            <template v-if="isMobile">

              <div class="table">

                  <section class="table__header base-color-30">

                      <section class="table__item--lg">

                          <h3>Dine varer</h3>

                      </section>

                  </section>

                  <section class="table__body">

                      <section class="table__row">

                          <section class="table__item--lg">

                              <p>{{product.title}}</p>

                          </section>

                          <section class="table__item--lg">

                              <p>{{orderDetails.product.quantity}}<span>stk.</span></p>

                          </section>

                          <section class="table__item--lg">

                              <p>{{formatCurrency(orderDetails.product.quantity * orderDetails.product.price)}}<span>DKK</span></p>

                          </section>

                      </section>

                      <template v-for="subProduct in orderDetails.subProducts">

                          <section class="table__row" v-if="subProduct.quantity > 0">

                              <section class="table__item--lg">

                                  <p>{{subProduct.title}}</p>

                              </section>

                              <section class="table__item--lg">

                                  <p>{{subProduct.quantity}}<span>stk.</span></p>

                              </section>

                              <section class="table__item--lg">

                                  <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                              </section>

                          </section>

                      </template>

                      <!-- spacer row -->

                      <section class="table__row padding-tb-15">

                          <section class="table__item--lg">

                          </section>

                      </section>

                      <!-- total price row -->

                      <section class="table__row">

                          <section class="table__item--lg">

                              <p>Samlet pris uden moms</p>

                          </section>

                          <section class="table__item--lg">

                              <p><strong>{{formatCurrency(totalWithoutTaxes)}}<span>DKK</span></strong></p>

                          </section>

                      </section>


                      <section class="table__row">

                          <section class="table__item--lg">

                              <p>Moms</p>

                          </section>

                          <section class="table__item--lg">

                              <p><strong>{{formatCurrency(totalTaxes)}}<span>DKK</span></strong></p>

                          </section>

                      </section>

                      <section class="table__row">

                          <section class="table__item--lg">

                              <p>Samlet pris</p>

                          </section>

                          <section class="table__item--lg">

                              <p><strong>{{formatCurrency(totalWithTaxes)}}<span>DKK</span></strong></p>

                          </section>

                      </section>

                  </section>

              </div>

            </template>

            <div class="shop-terms">

                <label><input type="checkbox" id="terms" name="terms" v-model="accepted">Jeg accepterer <a href="#" @click.prevent="openTerms">Næsbyhoved Skovs betingelser</a></label>

                <div class="col-12 margin-t-25">

                    <label><strong>OBS!</strong> billetter refunderes kun i forbindelse med aflysning.</label>

                </div>

                <terms-modal :show="termsModalOpen" @close="closeTerms">

                    <h3 slot="header">Handelsbetingelser</h3>

                    <div slot="content">


                      <h4>Generelle oplysninger</h4>

                      <ul>
                        <li>HMHJ Aps</li>
                        <li>Restaurationsvirksomhed</li>
                        <li>CVR.nr. 25246322</li>
                        <li>Sarumgårdsvej 1A</li>
                        <li>5290 Marslev</li>
                      </ul>

                      <ul>
                        <li><strong>Firma fysisk:</strong></li>
                        <li>Kanalvej 52</li>
                        <li>5000 Odense C</li>
                        <li>mh@nbhs.dk</li>
                        <li>Tlf. 66 12 05 10</li>
                        <li>Stiftet: 02.12.2013</li>
                      </ul>

                      <h4>Bestilling og afhentning</h4>

                      <p>Du kan afgive bestillinger online 24 timer i døgnet.</p>

                      <p>Når du har afgivet bestillingen og restauranten har modtaget din bestilling, sender vi
                      straks en ordrebekræftelse til dig pr. e-mail, som indeholder dit ordrenummer.</p>

                      <p>Ved køb af billetter / gavekort leveres der elektroniske billetter / gavekort til den e-mailadresse,
                        du indtaster i forbindelse med sit køb.</p>

                      <p>Du skal selv printe dine billetter / medbringe dem elektronisk til arrangementet.</p>

                      <p>Hvis du ikke kan finde billetten / gavekortet og/eller kvitteringen i din indbakke anbefaler vi, at du leder i sin spam-mappe.</p>

                      <p>Har du ikke modtaget din billet / gavekort en time efter købet, opfordrer vi til, at du henvender dig til HMHJ Aps på restaurant@nbhs.dk.</p>

                      <p>Ved køb af mad ud af huset, er du selv ansvarlig for at afhente bestillingen i restauranten, samt medbringe ordrenummeret.</p> </p>

                      <p>Levering er ikke muligt på online bestilling af mad ud af huset. Ønskes levering kan restauranten
                      kontaktes på telefon 66 12 03 10.</p>

                      <h4>Priser og betaling</h4>

                      <p>Betaling for din bestilling trækkes fra dit betalingskort med det samme.</p>

                      <p>Den gældende pris er den pris, som på tidspunktet for bestillingen er angivet i den samlede
                        oversigt over ordren, inden du accepterer. Alle opgivne priser er i danske kroner (DKK) inkl. moms (25 %).</p>

                      <p>Vi accepterer følgende betalingsmidler: VISA-Dankort, MasterCard, Maestro, VISA-Electron, JCB og American Express.</p>

                      <p>Vi krypterer alle dine kortoplysninger, med den såkaldte SSL (Secure Socket Layer) protokol. Det betyder, at uvedkommende
                      ikke kan aflæse dit kortnummer, eller andre informationer under transaktionen.</p>


                      <h4>Køb af billetter til events</h4>

                      <p>Billetten erstattes ikke ved bortkomst, så sørg for at gemme billetten i din indbakke.</p>

                      <p>Billetten refunderes kun i forbindelse med aflysning.</p>

                      <p>Billetten refunderes af HMHJ Aps, hvis det er i tilfælde af eventets aflysning. HMHJ Aps refunderer pengene så snart der foreligger en officiel meddelelse om aflysning.</p>

                      <p>Evt. billet- og kortgebyr refunderes ikke.</p>

                      <p>HMHJ Aps har intet ansvar i forbindelse med snyd, fejl og/eller kopiering af billetter.</p>


                      <h4>Køb af Gavekort</h4>

                      <p>Gavekort kan anvendes i 2 år fra udstedelsesdato og kan ikke fremdateres. Gavekortets udløbsdato vil altid fremgå af din faktura, samt på selve Gavekortet.</p>

                      <p>Gavekort kan kun anvendes hos Restaurant Næsbyhoved Skov og udskrives kun i danske kroner.</p>

                      <p>Et gavekort er et ihændehaverbevis og skal derfor betragtes som kontanter. Den person, der fremviser gavekortet, kan benytte dette til betaling. Der behøves ikke nogen yderligere identifikation af personen. Selvom du måtte have en bekræftelse fra gavegiveren, fra emballage eller kvittering, må vi desværre fastholde, at gavekortet alene har værdi for ihændehaver af gavekortet.</p>

                      <p>Tabte, bortkomne eller udløbne gavekort erstattes ikke.</p>

                      <p>Gavekortet kan indløses til kontanter på Restaurant Næsbyhoved Skov mod et gebyr på 50,00 DKK.</p>

                      <p>Evt. kortgebyr refunderes ikke.</p>

                      <p>HMHJ Aps har intet ansvar i forbindelse med snyd, fejl og/eller kopiering af gavekort.</p>


                      <h4>Klager, fortrydelsesret og reklamation</h4>

                      <p>Vi hører gerne fra dig, hvis du ikke er fuldt ud tilfreds med din bestilling, eller vores service. Hvis du har en klage,
                      kan du sende denne til os, via e-mail til restaurant@nbhs.dk. Du er også meget velkommen til at kontakte os på telefon: 66 12 05 10.</p>

                      <p>Hvis det ikke lykkes os at finde en løsning, kan du indgive en klage til Konkurrence- og Forbrugerstyrelsen, såfremt betingelserne herfor er opfyldt.</p>

                      <p>Bemærk, at der ikke er fortrydelsesret for mad og drikkevarer. Købelovens almindelige regler om reklamation i tilfælde af mangelfulde varer, forsinkede varer,
                      eller varer som ikke svarer til beskrivelsen, kan dog finde anvendelse.</p>

                      <p>Køb af event billetter er ikke dækket af fortrydelsesret jf. Forbrugeraftaleloven §18 Stk. 2 nr. 12</p>


                      <h4>Persondatapolitik og cookies</h4>

                      <p>Vi anvender cookies på <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a>. En cookie er en lille tekstfil, der bliver sendt fra hjemmesiden og gemt lokalt på din harddisk.
                        På den måde kan hjemmesiden gøre dit besøg nemmere.</p>

                      <p>De cookies, vi sender, er på ingen måde farlige for din computer. Vi bruger dem udelukkende til at give dig den bedste oplevelse.</p>

                      <p>For at du kan indgå aftale med os, har vi brug for følgende oplysninger:</p>

                      <ul>
                        <li>Navn</li>
                        <li>Adresse</li>
                        <li>Telefonnummer</li>
                        <li>E-mail adresse</li>
                      </ul>

                      <p>Vi foretager registreringen af dine personoplysninger med det formål, at kunne levere varen til dig.
                        Personoplysningerne registreres hos HMHJ ApS og opbevares i fem år, hvorefter oplysningerne slettes.</p>

                      <p>Når der indsamles personoplysninger, via vores website, sikrer vi, at det altid sker ved afgivelse af dit udtrykkelige samtykke,
                        således at du er informeret om præcis, hvilke oplysninger der indsamles og hvorfor.</p>

                      <p>Direktøren og den ansatte, som håndterer ekspeditionen for HMHJ ApS, har adgang til de oplysninger, der registreres om dig.</p>

                      <p>Direktøren og den ansatte er naturligvis underlagt tavshedspligt - også i forhold til dine personoplysninger.</p>

                      <p>Oplysninger afgivet til <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> videregives, eller sælges ikke til tredjemand.</p>

                      <h4>Logstatistik</h4>

                      <p>Logstatistik bruges på <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> og betyder, at et statistik-system opsamler information,
                        som kan give et statistisk billede af, hvor mange besøgende et website har haft, hvor de kommer fra, og på hvilken del af websitet dette forlades mm.</p>

                      <p>På <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> anvendes logstatistik med det formål, at optimere websitet og dets funktionalitet for dig som bruger. Vi ønsker, at dit besøg hos
                        os, skal være så relevant som muligt og vi vil gøre vort yderste for, at vise dig netop de områder, du helst vil se.</p>

                      <p>Ligesom vi også anvender statistik-værktøj i forhold til de e-mails, du vil modtage hvis du tilvælger nyhedsbrev.</p>

                    </div>

                    <div slot="footer">

                      <a class="btn--primary" href="#" @click.prevent="closeTerms">Ok, jeg er indforstået</a>

                    </div>

                </terms-modal>

            </div>

        </section>

        <section class="row border-t margin-t-25 padding-tb-50">

            <a class="margin-t-15 pull-left" href="#" @click.prevent="goBack">Gå tilbage</a>

            <a href="#" class="btn--primary pull-right" @click.prevent="fetchPaymentIntent" :class="{'disabled':isLoading || !validated}" :disabled="isLoading || !validated">

              <span>

                  <i class="spinner--light" v-if="isLoading"></i>

                  {{submitLabel}}

              </span>

            </a>

        </section>
    </div>


</template>

<script>
    var stripe = Stripe(stripeKey);
    var elements = stripe.elements();
    import {mapGetters, mapActions} from 'vuex';
    import Modal from '../modal/modal.vue';
    export default {
        data: function () {
            return {
                errors:{},
                accepted:false,
                termsModalOpen:false,
                isLoading:false,
                screenWidth:0,
              /*
              cardNumber: null,
                cardExpiry: null,
                cvc: null,
                cardImages: {
                    visa: '/images/visa-icon.svg',
                    mastercard: '/images/mastercard-icon.svg',
                    discover: '/images/discover-icon.svg',
                    jcb: '/images/jcb-icon.svg',
                    dinersclub: '/images/diners-club-icon.svg',
                    amex: '/images/american-express-icon.svg',
                },
                cardNumberInFocus: false,
                cardNumberValidated: false,
                currentCard: '',
                cardExpiryInFocus: false,
                expirationValidated: false,
                cardCvcInFocus: false,
                cvcValidated: false,
                enteredFields: [],
                paymentElement:null,

               */
            }
        },
        computed:{
            ...mapGetters({
                product:'getProduct',
                subProducts:'getSubProducts',
                orderDetails:'getDetails',
                information:'getInformation',
                cardToken:'getCardToken',
            }),
            submitLabel(){
               return (!this.isLoading) ? 'Gå til betaling' : 'Bearbejder betaling';
            },
            totalWithTaxes(){
                var productTotal = this.orderDetails.product.quantity * this.orderDetails.product.price;
                var subProductsTotal = 0;

                if (this.orderDetails.subProducts.length > 0) {
                    subProductsTotal = this.orderDetails.subProducts.map(function (item, index) {
                        return item.quantity * item.price;
                    }).reduce(function (a, b) {
                        return a + b
                    }, 0);
                }

                return productTotal + subProductsTotal;
            },
            totalTaxes(){
                return this.totalWithTaxes - this.totalWithoutTaxes;
            },
            totalWithoutTaxes(){
                return this.totalWithTaxes / 1.25;
            },
            isMobile(){
                return this.screenWidth <= 568;
            },
            cardType() {
                return (this.currentCard != 'unknown' && this.currentCard != '') ? this.cardImages[this.currentCard] : false;
            },
            hasEnteredCardNumber() {
                return this.fieldHasBeenEntered('card-number');
            },
            hasEnteredExpiry() {
                return this.fieldHasBeenEntered('expiry');
            },
            hasEnteredCvc() {
                return this.fieldHasBeenEntered('cvc');
            },
            validated(){
                return this.accepted;
            }
        },
        methods: {
            ...mapActions(['setInvoice', 'setStep', 'setLockBody', 'setCardError', 'setCardToken', 'setClientSecret']),
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }
            },
            initiatePayment(){

                if(this.isLoading){
                    return;
                }

                if(!this.validated){

                    Bugsnag.notify("UserCanSubmitWithoutValidation", this.enteredFields);

                    return;
                }

                this.requestCardToken();
            },
            formatCurrency(number){
                var formatter = new Intl.NumberFormat('da-DK', {
                    style: 'decimal',
                    currency: 'DKK',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                var stripePrice = number / 100;

                return formatter.format(stripePrice);
            },
            getSubProductById(id){
                return this.subProducts.filter(function(item, index){
                    return item.id == id;
                })[0];
            },
            openTerms(){
                this.termsModalOpen = true;

            },
            closeTerms(){
                this.termsModalOpen = false;
                this.setLockBody(false);
            },
             goBack(){
                if(!this.isLoading)
                {
                    this.setStep(1);
                }
            },
            fetchPaymentIntent(){
              this.isLoading = true;

              this.$http.post('/api/intent', {
                information:this.information,
                orderDetails:this.orderDetails,
                cardToken:'tempToken'
              }).then((response)=>{
                console.log(response);
                this.setClientSecret(response.data.data.client_secret);
                this.setStep(3);
              });
            }
        },
        components:{
            'terms-modal':Modal,
        },
        beforeMount(){
            this.screenWidth = window.innerWidth;

            window.addEventListener('resize', (event)=>{
                this.screenWidth = window.innerWidth;
            });
        },
        mounted() {

          /*
     const options = {

     }

     elements = stripe.elements();

     let base = {
         fontFamily: "'Work Sans', sans-serif",
         fontSize: '16px',
         fontWeight: '300',
         color: '#4a4847',
         '::placeholder': {
             color: "#bcb9b8",
         }
     };



     this.cardNumber = elements.create('cardNumber', {
         style: {
             base,
         },
         placeholder: 'f.eks. 9988 7733 8877 8822'
     });
     this.cardNumber.mount('#card-number');
     this.cardNumber.on('focus', (e) => {
         this.cardNumberInFocus = true;
     });

     this.cardNumber.addEventListener('change', (e) => {
         if (e.error) {
             this.cardNumberValidated = false;
         } else {
             if (e.complete && e.brand != 'unknown') {
                 this.cardNumberValidated = true;
             } else {
                 this.cardNumberValidated = false;
             }
         }
         this.currentCard = e.brand;
     });

     this.cardNumber.on('blur', (e) => {
         this.enteredField('card-number');
         this.cardNumberInFocus = false;
     });


     this.cardExpiry = elements.create('cardExpiry', {
         style: {
             base,
         },
         placeholder: 'MM / ÅÅ',
     });
     this.cardExpiry.mount('#card-expiry');
     this.cardExpiry.on('focus', (e) => {
         this.cardExpiryInFocus = true;
     });
     this.cardExpiry.on('blur', (e) => {
         this.enteredField('expiry');
         this.cardExpiryInFocus = false;
     });

     this.cardExpiry.addEventListener('change', (e) => {
         if (e.error) {
             this.expirationValidated = false;
         } else {
             if (e.complete) {
                 this.expirationValidated = true;
             } else {
                 this.expirationValidated = false;
             }
         }
     });

     this.cardCvc = elements.create('cardCvc', {
         style: {
             base,
         },
         placeholder: 'f.eks. 123',
     });
     this.cardCvc.mount('#card-cvc');
     this.cardCvc.on('focus', (e) => {
         this.cardCvcInFocus = true;
     });
     this.cardCvc.on('blur', (e) => {
         this.enteredField('cvc');
         this.cardCvcInFocus = false;
     });
     this.cardCvc.addEventListener('change', (e) => {
         if (e.error) {
             this.cvcValidated = false;
         } else {
             if (e.complete) {
                 this.cvcValidated = true;
             } else {
                 this.cvcValidated = false;
             }
         }
     });

*/
        },
    }
</script>
